import { Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IDynamicActions } from '@app/types/dynamic-actions';

@Component({
    selector: 'app-dynamic-actions',
    imports: [MatProgressSpinnerModule, MatButtonModule, MatIconModule],
    templateUrl: './dynamic-actions.component.html',
    styleUrls: ['./dynamic-actions.component.scss'],
})
export class DynamicActionsComponent {
    actions = input<IDynamicActions[]>([]);
    testIdPrefix = input<string>('');
    class = input<string>('');

    visibleActions = computed(() => {
        return this.actions().filter((action) => !action.hidden);
    });
}
